import { Guid } from "./CustomType"
import { TrainingDetail } from "./Training"

export const TrainingCourseTypes = ["Video", "Document"] as const

export interface TrainingCourseGet {
  id: Guid
  training: TrainingDetail
  name: string
  title: string
  description: string
  type: string
  contentUrl: string
  duration: string
  disclaimer?: string
  position: number
}

export interface TrainingCoursePost {
  name: string
  title: string
  description: string
  type: string
  contentUrl: string
  duration: string
  disclaimer?: string
  position: number
}

export interface TrainingCoursePut {
  name: string
  title: string
  description: string
  type: string
  contentUrl: string
  duration: string
  disclaimer?: string
  position: number
}
